import { jsxs as t, jsx as i } from "react/jsx-runtime";
import s from "react";
import a, { css as c } from "styled-components";
import { D as g, R as l } from "../chunks/Description.be3b00d1.js";
import { R as d, I as p } from "../chunks/index.5437e162.js";
const f = {
  Informative: "informative",
  Positive: "positive",
  Warning: "warning",
  Negative: "negative"
}, m = {
  informative: "InformationLine",
  positive: "PositiveLine",
  negative: "NegativeLine",
  warning: "WarningLine"
}, v = a.div.withConfig({
  displayName: "RangoFlag",
  componentId: "sc-o82vic-0"
})(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;gap:var(--spacing-1_5x);padding:var(--spacing-2x);border-radius:var(--default-border-radius);min-height:var(--size-10x);width:100%;box-sizing:border-box;", ""], ({
  type: o
}) => o && c(["background-color:var(--", "-bg-color-02);", "{color:var(--on-", "-description-color);}"], o, g, o)), x = a.div.withConfig({
  displayName: "Content",
  componentId: "sc-o82vic-1"
})(["display:flex;flex-direction:column;gap:var(--spacing-half);a{color:inherit;}"]), h = s.forwardRef(({
  type: o = f.Informative,
  children: n,
  ...e
}, r) => /* @__PURE__ */ t(v, { type: o, ref: r, role: "alert", "data-testid": "rango-flag", "data-rango-component": "rango-flag", "data-is-rango": !0, ...e, children: [
  /* @__PURE__ */ i(d, { type: o, size: p.MD, icon: m[o] }),
  /* @__PURE__ */ i(x, { children: /* @__PURE__ */ i(l, { children: n }) })
] }));
h.displayName = "RangoFlag";
export {
  h as RangoFlag
};
